import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { nativeLoad3gm9heja6i3t0 as nativeLoad } from './RawImageView.commonHtml.js.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  RawReactive253xb355brtjj as RawReactive,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { RView1jxdnn5qf89cm as RView } from '../RView.commonHtml.mjs';
import {
  vectorToSvgDataUrl2gfp16zcspd2w as vectorToSvgDataUrl,
  ImageResource1861inqz1dzjl as ImageResource,
} from '../../models/data.commonHtml.mjs';
import {
  ImageVector2g5mdtb71xbxl as ImageVector,
  ImageLocal23zvpfzvp93up as ImageLocal,
  ImageRaw13ec2czmt8f60 as ImageRaw,
  ImageRemote256pcav1ipbca as ImageRemote,
} from '../../models/data.mjs';
import {
  createObjectURLFileReference3o8golj1mnrvr as createObjectURLFileReference,
  createObjectURLBlob28c4i1stg1nh2 as createObjectURLBlob,
} from './ImageView.commonHtml.js.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RawImageViewClass;
function RawImageView() {
  if (RawImageViewClass === VOID) {
    class $ extends RawImageViewLike() {
      constructor(context, source, description, scaleType) {
        super(context, source, description, scaleType);
        this.tb5_1.xb3_1 = 'img';
        this.tb5_1.hb4_1.v('viewDraws');
        this.pca_1 = this.dcc_1;
        nativeLoad(this, this.ecc(source));
      }
    }
    initMetadataForClass($, 'RawImageView');
    RawImageViewClass = $;
  }
  return RawImageViewClass;
}
var RawImageViewZoomableClass;
function RawImageViewZoomable() {
  if (RawImageViewZoomableClass === VOID) {
    class $ extends RawImageViewLike() {
      constructor(context, source, description, scaleType) {
        super(context, source, description, scaleType);
        this.tb5_1.xb3_1 = 'img';
        this.tb5_1.hb4_1.v('viewDraws');
        this.tcd_1 = this.dcc_1;
        nativeLoad(this, this.ecc(source));
        this.ucd_1 = Signal().fak(Unit_instance);
      }
    }
    initMetadataForClass($, 'RawImageViewZoomable');
    RawImageViewZoomableClass = $;
  }
  return RawImageViewZoomableClass;
}
var RawImageViewLikeClass;
function RawImageViewLike() {
  if (RawImageViewLikeClass === VOID) {
    class $ extends RView() {
      constructor(context, source, description, scaleType) {
        super(context);
        this.acc_1 = source;
        this.bcc_1 = description;
        this.ccc_1 = scaleType;
        this.dcc_1 = RawReactive().yah();
        this.tb5_1.hb4_1.v('scaleType-' + this.ccc_1.toString());
      }
      ecc(_this__u8e3s4) {
        var value = _this__u8e3s4;
        var tmp;
        if (value == null) {
          tmp = '';
        } else {
          if (value instanceof ImageRemote()) {
            tmp = value.xcd_1;
          } else {
            if (value instanceof ImageRaw()) {
              tmp = createObjectURLBlob(value.wcd_1);
            } else {
              if (value instanceof ImageResource()) {
                tmp = this.pc().mb3_1 + value.qay_1;
              } else {
                if (value instanceof ImageLocal()) {
                  tmp = createObjectURLFileReference(value.vcd_1);
                } else {
                  if (value instanceof ImageVector()) {
                    tmp = vectorToSvgDataUrl(value);
                  } else {
                    tmp = '';
                  }
                }
              }
            }
          }
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'RawImageViewLike');
    RawImageViewLikeClass = $;
  }
  return RawImageViewLikeClass;
}
//region block: exports
export {
  RawImageViewZoomable as RawImageViewZoomable3s4y58x72taln,
  RawImageView as RawImageView3rlp4gsc2bxt0,
};
//endregion

//# sourceMappingURL=RawImageView.commonHtml.mjs.map
